import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { AnchorExtensionHandlerProps } from '../src/AnchorExtensionHandler.tsx';

export const AnchorExtensionHandler: LoadableType<AnchorExtensionHandlerProps> = LoadableAfterPaint(
	{
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-AnchorExtensionHandler" */ '../src/AnchorExtensionHandler.tsx'
				)
			).AnchorExtensionHandler,
	},
);
